import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Col, Grid, Row} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import NewSubstanceForm  from "./NewSubstanceForm";
import { newSubstance } from "../../../redux/actions/substance";

class NewSubstance extends Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.sub ={
            name: '',
            value: ''
        }
        this.state = this.sub;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
       if(this.props.message) {
           if(!prevProps.message) {
               this.props.showNotification(this.props.message.message, this.props.message.status);
               if(this.props.message.status === 'success') {
                   this.setState(this.sub);
               }
           }  
           else if(prevProps.message.timestamp !== this.props.message.timestamp) {
               this.props.showNotification(this.props.message.message, this.props.message.status);
               if(this.props.message.status === 'success') {
                   this.setState(this.sub);
               }
           }
       }
   }
    setName = (val) => {this.setState({name: val})};
    setValue = (val) => {this.setState({value: val})};
    onSubmit(event) {
        event.preventDefault();
            const sub = {
                name: this.state.name,
                value: this.state.value
            };
            this.props.newSubstance(sub);
    }  
     
    render() {
        if(this.props.substance === null){
            return null;
        }
        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <form onSubmit={this.onSubmit}>
                                <NewSubstanceForm 
                                    stateName={this.state.name}
                                    stateValue ={this.state.value}
                                    setName={this.setName}
                                    setValue={this.setValue}
                                />
                                <div className="text-center">
                                    <Button bsStyle="info" fill type="submit">
                                        <span className="btn-label" style={{marginRight: '4px'}}>
                                            <i className="fa fa-save"/>
                                        </span>
                                        Enregistrer
                                    </Button>
                                </div>
                            </form>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        newSubstance: substance => {
            dispatch(newSubstance(substance));
        }
    }
}


NewSubstance.propTypes = {
    loading: PropTypes.bool,
    state: PropTypes.object,
    substance: PropTypes.object,
    message: PropTypes.object,
    newSubstance: PropTypes.func,
    showNotification: PropTypes.func
};

export default connect(mapStateToProps,mapDispatchToProps)(NewSubstance);


